import React from 'react';
import { Chip } from '@mui/material';
import { getStatusChipProps } from '../../utils/statusUtils';

/**
 * Composant réutilisable pour afficher un chip de statut
 * @param {Object} props - Props du composant
 * @param {string} props.status - Statut à afficher
 * @param {'reservation' | 'payment'} props.type - Type de statut (par défaut: 'reservation')
 * @param {'small' | 'medium'} props.size - Taille du chip (par défaut: 'small')
 * @param {Object} props.sx - Styles Material-UI additionnels
 * @param {Object} rest - Autres props transmises au Chip
 */
const StatusChip = ({ 
  status, 
  type = 'reservation', 
  size = 'small',
  sx = {},
  ...rest 
}) => {
  const chipProps = getStatusChipProps(status, type);
  
  return (
    <Chip
      {...chipProps}
      size={size}
      sx={{
        ...chipProps.sx,
        ...sx
      }}
      {...rest}
    />
  );
};

export default StatusChip;
